module.exports = __webpack_public_path__ + "static/img/Cooperative unit.bfa2b34e.png";